import { IonIcon } from "@ionic/react";

import { Fab as MuiFab } from "@material-ui/core";

import { FBAProps } from "src/utils/interfaces";

// FAB: Floating Action Button
const FAB: React.FC<FBAProps> = (props: FBAProps) => {
  return (
    <MuiFab className="fab" onClick={props.handleClick} color="primary">
      <IonIcon icon={props.icon} />
    </MuiFab>
  );
};

export default FAB;
